import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import ToggleSwitch from './ToggleSwitch';
import './FilterModal.css';

const PoliticalViewsModal = ({ show, onHide, value, onUpdate }) => {
  const [selectedValue, setSelectedValue] = useState(value || '');
  const [showOthers, setShowOthers] = useState(false);

  const politicalOptions = [
    'Very conservative',
    'Somewhat conservative',
    'Moderate',
    'Somewhat liberal',
    'Very liberal',
    'Prefer not to say',
    'I hate politics'
  ];

  const handleOptionSelect = (option) => {
    setSelectedValue(option);
  };

  const handleApply = () => {
    onUpdate(selectedValue);
    onHide();
  };

  const handleClear = () => {
    setSelectedValue('');
    onUpdate('');
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered className="filter-modal">
      <Modal.Header closeButton>
        <Modal.Title>What are their political views?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="filter-checkbox-group">
          {politicalOptions.map((option) => (
            <div
              key={option}
              className={`filter-checkbox-option ${selectedValue === option ? 'selected' : ''}`}
              onClick={() => handleOptionSelect(option)}
            >
              <input
                type="radio"
                id={`political-${option}`}
                name="political"
                value={option}
                checked={selectedValue === option}
                onChange={() => handleOptionSelect(option)}
              />
              <label htmlFor={`political-${option}`}>{option}</label>
            </div>
          ))}
        </div>
        
        {/* Toggle Switch */}
        <ToggleSwitch 
          checked={showOthers} 
          onChange={setShowOthers}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClear} className="filter-modal-btn secondary">
          Clear
        </Button>
        <Button variant="primary" onClick={handleApply} className="filter-modal-btn primary">
          Apply
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PoliticalViewsModal;
